export function PricingUsageDetails() {
  return (
    <div className="container mx-auto bg-purple-100 rounded-xl py-8 p-3 lg:p-8 mt-20 mb-8">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-black mb-4">Usage-Based Billing</h3>
        <p className="text-black max-w-3xl mx-auto">Lavender Flow works on a pre-paid credit system, so you don't get surprise bills.</p>
        <p>Pay only for what you use. Your workflows can run indefinitely until you run out of credits.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-lg border border-purple-300">
          <div className="flex items-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-purple-400 mr-3">
              <rect x="4" y="4" width="16" height="16" rx="2" ry="2" />
              <rect x="9" y="9" width="6" height="6" />
              <path d="m15 2 5 5" />
              <path d="m9 22 5-5" />
            </svg>
            <h4 className="text-lg font-semibold text-black">Runtime</h4>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-purple-900">CPU</span>
              <span className="text-black font-medium">$0.10/hour</span>
            </div>
            <div className="flex justify-between">
              <span className="text-purple-900">Storage (KVDB)</span>
              <span className="text-black font-medium">$0.80/GB/month</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg border border-purple-300">
          <div className="flex items-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-purple-400 mr-3">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z" />
              <path d="M3 6h18" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            <h4 className="text-lg font-semibold text-black">GPU</h4>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-purple-900">T4 GPU</span>
              <span className="text-black font-medium">$0.50/hour</span>
            </div>
            <div className="flex justify-between">
              <span className="text-purple-900">A100 GPU</span>
              <span className="text-black font-medium">$2.50/hour</span>
            </div>
          </div>
        </div>

        <div className="bg-white p-6 rounded-lg border border-purple-300">
          <div className="flex items-center mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-purple-400 mr-3">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
              <line x1="12" y1="22.08" x2="12" y2="12" />
            </svg>
            <h4 className="text-lg font-semibold text-black">Network</h4>
          </div>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-purple-900">Run over API</span>
              <span className="text-black font-medium">$0.0004/run</span>
            </div>
            <div className="flex justify-between">
              <span className="text-purple-900">Network Egress</span>
              <span className="text-black font-medium">$0.08/GB</span>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 p-4 bg-white rounded-lg border border-purple-700">
        <div className="flex items-start">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-purple-400 mr-3 mt-0.5 flex-shrink-0">
            <circle cx="12" cy="12" r="10" />
            <path d="m9 12 2 2 4-4" />
          </svg>
          <div>
            <p className="text-purple-900 text-sm">
              <strong className=""></strong> You aren't charged for CPU time if your active deployments are waiting for events at designated
              waiting nodes.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
